import { currencyFormatter } from "../../../../records/csv/formatters";
import { moneyValueGetterFactory } from "../../../../records/grids/cells/valueGetters";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import fieldHelpers from "../../../../ui-formly/fieldHelpers";
import { simpleLookupConfig } from "../../../shared/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "machineDenomination";

const url = "/api/machines/MachineDenomination";

export const machineDenominationLookupConfig = simpleLookupConfig({
  name: vsObjectName,
  nameSingular: "Denomination",
  url,
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
  additionalColumns: [
    ColumnDefinitionServiceName,
    (columnDefinitionService: ColumnDefinitionService) => [
      columnDefinitionService.getNumberColDef({
        field: "Value",
      }),
    ],
  ],
  additionalFields: [
    () => [
      fieldHelpers.simpleNumberField({
        key: "Value",
        required: true,
        min: 0,
        step: 0.01,
      }),
    ],
  ],
});
